(() => {
  const root = document.querySelector('[data-ab-faux]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';

  const form = root.querySelector('form');
  const matrix = JSON.parse(root.querySelector('[data-ab-matrix]').textContent);
  const variant = root.querySelector('[data-ab-variant]');
  const price = root.querySelector('[data-ab-price]');
  const message = root.querySelector('[data-ab-message]');
  const add = root.querySelector('[data-ab-add]');
  const buy = root.querySelector('[data-ab-buy]');
  const quantity = root.querySelector('[data-ab-quantity]');
  const quantityControls = quantity.closest('.ab-faux__quantity').querySelector('div');
  quantity.type = 'hidden';
  quantity.max = '999';
  quantityControls.innerHTML = `<select data-ab-quantity-select aria-label="Quantity">${Array.from({ length: 10 }, (_, index) => `<option value="${index + 1}">${index + 1}</option>`).join('')}<option value="11+">11+</option></select><input type="number" min="11" max="999" value="11" inputmode="numeric" aria-label="Enter quantity of 11 or more" data-ab-quantity-custom hidden>`;
  form.appendChild(quantity);
  const quantitySelect = quantityControls.querySelector('[data-ab-quantity-select]');
  const quantityCustom = quantityControls.querySelector('[data-ab-quantity-custom]');
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  let selectedImage = '';
  let selectedColor = '';
  let currentPrice = null;
  const syncQuantityFromControls = () => {
    const isCustom = quantitySelect.value === '11+';
    quantityCustom.hidden = !isCustom;
    const nextValue = isCustom
      ? Math.min(999, Math.max(11, Number(quantityCustom.value) || 11))
      : Math.min(10, Math.max(1, Number(quantitySelect.value) || 1));
    quantity.value = String(nextValue);
    return nextValue;
  };
  const requestedColor = (() => {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('color') || params.get('finish') || params.get('ad_color') || '';
    const normalized = raw.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
    if (['black', 'black-wps', 'wps-black'].includes(normalized)) return 'wps-n010';
    if (['black-ash', 'black-ash-wps'].includes(normalized)) return 'wps-n046';
    return normalized;
  })();

  const label = (whole, fraction) => `${whole}${['', ' 1/8', ' 1/4', ' 3/8', ' 1/2', ' 5/8', ' 3/4', ' 7/8'][Math.round(fraction * 8)] || ''} in`;
  const fieldValue = (name) => {
    const field = [...form.elements].find((item) => item.name === name && (item.type !== 'radio' || item.checked));
    return field ? field.value : '';
  };
  const configurationSummary = () => {
    const width = fieldValue('properties[Finished width]');
    const height = fieldValue('properties[Finished height]');
    return [
      fieldValue('properties[Material]'),
      fieldValue('properties[Color]'),
      width && height ? `${width} W × ${height} H` : 'Size not complete',
      fieldValue('properties[Mount type]'),
      fieldValue('properties[Lift / Control]'),
      fieldValue('properties[Ladder style]'),
      `Qty ${Number(quantity.value) || 1}`,
    ].filter(Boolean).join(' · ');
  };

  function notify(complete = false) {
    const summary = configurationSummary();
    const quantityValue = Number(quantity.value) || 1;
    const totalPrice = Number.isFinite(currentPrice) ? currentPrice * quantityValue : null;
    const reviewSummary = root.querySelector('[data-ab-review-summary]');
    if (reviewSummary) reviewSummary.textContent = summary;
    document.dispatchEvent(new CustomEvent('airyblinds:faux-config-change', {
      detail: {
        productId: root.dataset.productId,
        variantId: variant.value,
        priceCents: Number.isFinite(totalPrice) ? Math.round(totalPrice * 100) : null,
        formattedPrice: Number.isFinite(totalPrice) ? money.format(totalPrice) : 'Enter dimensions',
        formattedUnitPrice: Number.isFinite(currentPrice) ? money.format(currentPrice) : null,
        primaryImage: selectedImage,
        color: selectedColor,
        complete,
        quantity: Number(quantity.value) || 1,
        summary,
      },
    }));
  }

  function selectColor(input) {
    const card = input.closest('label');
    hydrateColorImage(card);
    const gallery = [...card.querySelectorAll('template i')].map((item) => item.dataset.src);
    const primaryAsset = input.dataset.primary;
    const assetSeparator = primaryAsset.includes('?') ? '&' : '?';
    selectedImage = `${primaryAsset}${assetSeparator}width=1200`;
    selectedColor = input.value;
    root.querySelector('[data-ab-color-property]').value = selectedColor;
    const previewImage = root.querySelector('[data-ab-faux-preview]');
    previewImage.src = selectedImage;
    previewImage.srcset = [480, 720, 960, 1200].map((width) => `${primaryAsset}${assetSeparator}width=${width} ${width}w`).join(', ');
    root.querySelector('[data-ab-faux-preview]').alt = selectedColor;
    root.querySelector('[data-ab-faux-preview-title]').textContent = selectedColor;
    const thumbs = root.querySelector('[data-ab-faux-thumbs]');
    thumbs.innerHTML = '';
    gallery.forEach((src, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.innerHTML = `<img src="${src}${src.includes('?') ? '&' : '?'}width=180" alt="${selectedColor} view ${index + 1}" loading="lazy" decoding="async">`;
      button.onclick = () => { root.querySelector('[data-ab-faux-preview]').src = src; };
      thumbs.append(button);
    });
    notify(false);
  }

  function hydrateColorImage(card) {
    const image = card && card.querySelector('img[data-src]');
    if (image) { image.src = image.dataset.src; image.removeAttribute('data-src'); }
  }

  const colorObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.hidden) {
        hydrateColorImage(entry.target);
        colorObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '240px 0px' }) : null;
  root.querySelectorAll('[data-ab-color-card]').forEach((card) => {
    if (colorObserver) colorObserver.observe(card);
    else if (!card.hidden) hydrateColorImage(card);
  });

  const deferredImageObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const image = entry.target;
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
      deferredImageObserver.unobserve(image);
    });
  }, { rootMargin: '320px 0px' }) : null;
  root.querySelectorAll('img[data-src]:not([data-ab-color-card] img)').forEach((image) => {
    if (deferredImageObserver) deferredImageObserver.observe(image);
    else { image.src = image.dataset.src; image.removeAttribute('data-src'); }
  });

  function filterColors(materialInput) {
    const series = materialInput.dataset.abMaterial;
    root.querySelector('[data-ab-material-series]').value = series;
    const cards = [...root.querySelectorAll('[data-ab-color-card]')];
    cards.forEach((card) => {
      const active = card.dataset.material === series;
      card.hidden = !active;
    });
    let selected = root.querySelector('[name="ab-faux-color"]:checked');
    if (!selected || selected.dataset.material !== series) {
      if (selected) selected.checked = false;
      selected = root.querySelector(`[name="ab-faux-color"][data-material="${series}"]`);
      selected.checked = true;
    }
    selectColor(selected);
  }

  function applyRequestedColor() {
    if (!requestedColor) return false;
    const requested = [...root.querySelectorAll('[name="ab-faux-color"]')].find((input) => {
      const code = (input.dataset.code || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
      const value = (input.value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
      return code === requestedColor || value === requestedColor || value.includes(requestedColor);
    });
    if (!requested) return false;
    const material = root.querySelector(`[data-ab-material="${requested.dataset.material}"]`);
    if (material) material.checked = true;
    filterColors(material);
    root.querySelectorAll('[name="ab-faux-color"]').forEach((input) => { input.checked = input === requested; });
    selectColor(requested);
    return true;
  }

  function calc() {
    syncQuantityFromControls();
    const ww = Number(root.querySelector('[data-ab-width-whole]').value);
    const wf = Number(root.querySelector('[data-ab-width-frac]').value);
    const hw = Number(root.querySelector('[data-ab-height-whole]').value);
    const hf = Number(root.querySelector('[data-ab-height-frac]').value);
    currentPrice = null;
    if (!ww || !hw) {
      add.disabled = buy.disabled = true;
      price.textContent = 'Enter dimensions';
      notify(false);
      return;
    }
    const bw = Math.ceil(ww + wf - 1e-9);
    const bh = Math.ceil(hw + hf - 1e-9);
    const index = (bw - matrix.width.min) * (matrix.height.max - matrix.height.min + 1) + (bh - matrix.height.min);
    const tierIndex = matrix.grid[index];
    const amount = Number(matrix.tierPrices[tierIndex]);
    const variantId = matrix.tierVariantIds[tierIndex];
    if (!Number.isFinite(amount) || !variantId) {
      add.disabled = buy.disabled = true;
      message.textContent = 'No matching price was found.';
      notify(false);
      return;
    }
    currentPrice = amount;
    variant.value = String(variantId).split('/').pop();
    root.querySelector('[data-ab-width-property]').value = label(ww, wf);
    root.querySelector('[data-ab-height-property]').value = label(hw, hf);
    root.querySelector('[data-ab-billed-width]').value = `${bw} in`;
    root.querySelector('[data-ab-billed-height]').value = `${bh} in`;
    root.querySelector('[data-ab-tier]').value = matrix.tierCodes[tierIndex];
    const quantityValue = Number(quantity.value) || 1;
    price.textContent = money.format(amount * quantityValue);
    message.textContent = quantityValue > 1
      ? `${quantityValue} blinds × ${money.format(amount)} each. Priced at the ${bw} W × ${bh} H whole-inch matrix band.`
      : `Unit price. Priced at the ${bw} W × ${bh} H whole-inch matrix band.`;
    const complete = form.checkValidity();
    add.disabled = buy.disabled = !complete;
    notify(complete);
  }

  root.querySelectorAll('[name="ab-faux-color"]').forEach((input) => input.addEventListener('change', () => {
    selectColor(input);
    calc();
  }));
  root.querySelectorAll('[data-ab-material]').forEach((input) => input.addEventListener('change', () => {
    filterColors(input);
    calc();
  }));
  form.addEventListener('input', calc);
  form.addEventListener('change', calc);
  const applyQuantity = () => {
    syncQuantityFromControls();
    calc();
  };
  quantitySelect.addEventListener('change', applyQuantity);
  quantityCustom.addEventListener('input', applyQuantity);
  quantity.addEventListener('input', () => {
    const value = Math.min(999, Math.max(1, Number(quantity.value) || 1));
    if (value <= 10) {
      quantitySelect.value = String(value);
      quantityCustom.hidden = true;
    } else {
      quantitySelect.value = '11+';
      quantityCustom.value = String(value);
      quantityCustom.hidden = false;
    }
    calc();
  });
  // AB_META_ATC_V3: wait for the Shopify/Meta channel event before navigation.
  const addConfiguredItem = async (destination) => {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    if (!response.ok) throw new Error('cart/add failed');
    const item = await response.json();
    await new Promise((resolve) => setTimeout(resolve, 300));
    location.assign(`${window.Shopify.routes.root}${destination}`);
    return item;
  };
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    syncQuantityFromControls();
    calc();
    if (!form.reportValidity() || add.disabled) return;
    add.disabled = true;
    try { await addConfiguredItem('cart'); }
    catch { message.textContent = 'Unable to add this configuration.'; add.disabled = false; }
  });

  buy.addEventListener('click', async () => {
    syncQuantityFromControls();
    calc();
    if (!form.reportValidity()) return;
    buy.disabled = true;
    try { await addConfiguredItem('checkout'); }
    catch { message.textContent = 'Unable to add this configuration.'; buy.disabled = false; }
  });
  if (!applyRequestedColor()) filterColors(root.querySelector('[data-ab-material]:checked'));
  calc();
  setTimeout(calc, 0);
})();
